import { useField } from "formik"
import { PaymentMethodType } from "../../../../../../modules/payments/paymentTypes"
import { SelectedMainUserState } from "../../../../createOrder/createOrderTypes"
import { BuyerPartiesAutocomplete } from "./BuyerPartiesAutocomplete"
import {
    DynamicConfigField,
    DynamicConfigKey,
    PaymentMethodOption,
    PaymentMethodOptionValue,
} from "../../form/formTypes"

type BuyerPartiesControllerProps = Readonly<{
    config: DynamicConfigField
    user: SelectedMainUserState
    isCreateBuyerParty?: boolean
}>

export function BuyerPartiesController({ config, user, isCreateBuyerParty }: BuyerPartiesControllerProps) {
    const [{ value: paymentMethodFieldValue }] = useField<PaymentMethodOption>(DynamicConfigKey.PAYMENT_METHOD)
    const paymentValue: PaymentMethodOptionValue = paymentMethodFieldValue?.value

    return paymentValue === PaymentMethodType.INVOICE ? (
        <BuyerPartiesAutocomplete config={config} user={user} showCreateButton={isCreateBuyerParty} />
    ) : null
}
